import getStorageValue from '~/misc/getStorageValue';
import safeJSONParse from '~/misc/safeJSONParse';
import LOADS from '~/modules/loads/types';

const init = () => {
  const saved = safeJSONParse(getStorageValue('introduction')) || {};
  return {
    loadOpened: 0,
    ...saved,
  };
};

const reducer = (state, action) => {
  switch (action.type) {
    case LOADS.SEARCH_LOAD_ACTIVE: {
      return {
        loadOpened: 1,
      };
    }
  }

  return null;
};

export default {reducer, init};



// WEBPACK FOOTER //
// ./src/modules/introduction/reducer.js